var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.968,
    height: 13.085,
    viewBox: "0 0 16.968 13.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_3-User",
    "data-name": "Iconly/Light-Outline/3-User",
    transform: "translate(-1 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3-User",
    "data-name": "3-User",
    transform: "translate(1 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M8.484,8.116h.285c1.5.01,4.943.162,4.943,2.492,0,2.315-3.318,2.466-4.919,2.476H8.2c-1.5-.01-4.944-.162-4.944-2.489S6.695,8.126,8.2,8.117h.285Zm0,1.169c-1.852,0-4.06.228-4.06,1.311,0,1.059,2.076,1.306,3.89,1.32h.169c1.852,0,4.059-.227,4.059-1.308S10.336,9.285,8.484,9.285Zm6.2-1.485c1.888.283,2.285,1.17,2.285,1.864a1.711,1.711,0,0,1-1.281,1.623.591.591,0,0,1-.208.038.585.585,0,0,1-.208-1.131c.528-.2.528-.423.528-.53,0-.341-.434-.58-1.29-.708A.585.585,0,1,1,14.683,7.8ZM2.951,8.291a.586.586,0,0,1-.492.666c-.856.128-1.29.366-1.29.708,0,.107,0,.328.529.53a.585.585,0,0,1-.208,1.131.591.591,0,0,1-.208-.038A1.712,1.712,0,0,1,0,9.664C0,8.97.4,8.083,2.286,7.8A.588.588,0,0,1,2.951,8.291ZM8.484,0a3.561,3.561,0,1,1,0,7.121H8.463A3.55,3.55,0,0,1,4.924,3.558,3.564,3.564,0,0,1,8.484,0Zm0,1.169A2.394,2.394,0,0,0,6.093,3.561,2.38,2.38,0,0,0,8.465,5.953l.019.584V5.953a2.392,2.392,0,1,0,0-4.784ZM13.308.763a2.822,2.822,0,0,1-.066,5.58.574.574,0,0,1-.081.005.585.585,0,0,1-.08-1.164,1.653,1.653,0,0,0,.037-3.268.584.584,0,0,1,.19-1.153Zm-8.975.482a.585.585,0,0,1-.482.672,1.653,1.653,0,0,0,.037,3.268.585.585,0,0,1-.08,1.164.574.574,0,0,1-.081-.005A2.822,2.822,0,0,1,3.661.763.581.581,0,0,1,4.333,1.245Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/Groups.ec1344bc291e71e5d7d8d13e38bb9745.svg";
export { ForwardRef as ReactComponent };